import { inject, Injectable, Signal } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { tapResponse } from '@ngrx/operators';
import { Observable, switchMap } from 'rxjs';
import { ELoadStatus } from '../../../state/state.interface';
import { AiReportCommentButtonService } from './ai-report-comment-button.service';

export interface IAiReportCommentButtonState {
  status: ELoadStatus;
}

@Injectable()
export class AiReportCommentButtonStore extends ComponentStore<IAiReportCommentButtonState> {
  private readonly service = inject(AiReportCommentButtonService);

  public readonly status: Signal<ELoadStatus> = this.selectSignal((state) => state.status);

  /** Errors are shown by the global HTTP error handling; the button comes back, so the user can try again. */
  public readonly addComment = this.effect((trigger$: Observable<{ itemId: number; description: string }>) =>
    trigger$.pipe(
      switchMap(({ description, itemId }) => {
        this.patchState({ status: ELoadStatus.loading });

        return this.service.addComment(itemId, description).pipe(
          tapResponse(
            () => this.patchState({ status: ELoadStatus.success }),
            () => this.patchState({ status: ELoadStatus.initial }),
          ),
        );
      }),
    ),
  );

  constructor() {
    super({ status: ELoadStatus.initial });
  }
}
